var App = App || {};

App.SmartAppBanner = (function ($) {
    "use strict";

    function init() {

        new SmartBanner({
            daysHidden: 15,
            daysReminder: 90,
            appStoreLanguage: 'us',
            title: 'BancFirst Mobile',
            author: 'BancFirst Corporation',
            button: 'View',
            store: {
                ios: 'On the App Store',
                android: 'In Google Play'
            },
            price: {
                ios: 'FREE',
                android: 'FREE'
            }
        });

        var $smartbanner = $(".smartbanner"),
            $smartbannerButton = $smartbanner.find(".smartbanner-button"),
            $smartbannerContainer = $(".smartbanner-container");

        $smartbanner.prependTo("section.navigation.mobile");

        $smartbannerButton
            .addClass("btn btn-sm btn-primary px-2")
            .removeClass("smartbanner-button")
            .children("span")
            .removeClass("smartbanner-button-text");

        $smartbannerContainer.addClass("container");

    }

    return {
        init: init
    }

})(jQuery);

$(function () {
    App.SmartAppBanner.init();
});